function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Danger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "DangerIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M3.708 21c-.294 0-.582-.075-.837-.218a1.685 1.685 0 0 1-.651-2.305l8.292-14.614a1.715 1.715 0 0 1 2.976 0l8.293 14.614c.143.254.219.54.219.83A1.7 1.7 0 0 1 20.293 21H3.708zm8.33-4.708c.66 0 1.197.531 1.197 1.187s-.536 1.188-1.198 1.188a1.193 1.193 0 0 1-1.197-1.188c0-.655.536-1.187 1.197-1.187zm1.072-8.543v6.333h-2.155V7.75h2.155z",
      clipRule: "evenodd"
    })
  }));
});
Danger.displayName = 'DangerIcon';
export default Danger;